<div class="container">
  <label class="main-label">{{ trackReports.varianceReportLabel }}:</label>
  <div class="input-group">
    <label class="sub-label">{{ trackReports.contractor }}:</label>
    <input type="text" class="input-field" [(ngModel)]="contractor" disabled />
  </div>

  <div class="input-group">
    <label class="sub-label">{{ trackReports.date }}:</label>
    <input
      type="text"
      class="input-field"
      [(ngModel)]="contractorDate"
      disabled
      />
    </div>
    @if (isRunVariance) {
      <div class="redmsg">
        {{ trackReports.fileFormat }}
      </div>
    }
    <button
      class="center-button"
      [disabled]="isRunVariance || !isDataAvailable"
      (click)="runVarianceReports()"
      >
      {{ trackReports.runReport }}
    </button>
  </div>
